import React, { useEffect, useState } from "react";
import cn from "classnames";
import { func } from "../../../utils";
import Text from "../Text";
import PropTypes from "prop-types";
import Button from "../Button";
import { useLocation, useNavigate } from "react-router-dom";
import { isLiveStreamingDate, scrollTo } from "../../../utils/function";
import {
  usePageContextFunction,
  usePageContextState,
} from "../../../context/PageContext";
import analytics from "../../../utils/analytics";
import useWindowSize from "../../../hooks/useWindowSize";
import { ReactComponent as ChevronRight } from "../../../assets/img/illustrations/ArrowRight.svg";
import { useCategoryCompetition, useCitySchool } from "../../../store/user";
const NavBarBreadCrumb = ({
  menus,
  className,
  pageType,
  isShowBurger = true,
}) => {
  const { size } = useWindowSize();

  const isSmallScreen = (size?.height || 0) <= 667;
  const isMobileView = (size?.width || 0) <= 768;
  const [offset, setOffset] = useState(0);
  const [showNavigationMenu, setShowNavigationMenu] = useState(false);
  const { city, idInView, isLive, videoUrl, isRegist, registrationUrl } =
    usePageContextState();
  const { setIdInView } = usePageContextFunction();
  const { citySchool, setCitySchool } = useCitySchool();
  const { categoryCompetition, setCategoryCompetition } =
    useCategoryCompetition();
  const { setOpenPopUp: toglePopUp } = usePageContextFunction();
  const navigate = useNavigate();
  const location = useLocation();
  const sections = document.querySelectorAll("section");
  const navLi = document.querySelectorAll(".navbar__container__inner__text");
  const isNavOffset = offset > 0;
  const navOffSetExclusion = idInView === "hall-of-fame" && isNavOffset;
  const rootUrl = city
    ? `https://pialabyu.com/${city}`
    : "https://pialabyu.com";
  const classNames = cn("navbar__container", className, {
    navbar__container__scroll: true,
    navbar__container__scroll__dynamicHighlight: navOffSetExclusion,
  });

  const classNamesNavbar = cn("navbar__container__inner", {
    navbar__container__inner__shadow:
      location.pathname === "/" &&
      ["footer-landing", "journey"].includes(idInView),
  });

  const queryString = location.pathname;

  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset);
    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    // showNavigationMenu (Mobile Menu)

    if (showNavigationMenu) {
      document.body.classList.add("show-navigation");
      document.body.classList.add("rm-scroll");
    } else {
      document.body.classList.remove("show-navigation");
      document.body.classList.remove("rm-scroll");
    }
  }, [showNavigationMenu]);
  // window.onscroll = () => {
  //   let current = "";
  //   sections.forEach((section) => {
  //     const sectionTop = section.offsetTop;
  //     const sectionHeight = section.offsetHeight;

  //     if (window.pageYOffset >= sectionTop - sectionHeight / 2) {
  //       current = section.getAttribute("id");
  //     }
  //   });

  //   navLi.forEach((div) => {
  //     div.classList.remove("navbar__container__inner__text__active");

  //     if (div.classList.contains(current)) {
  //       div.classList.add("navbar__container__inner__text__active");
  //     }
  //   });
  // };
  const handleNavigationMenu = () => {
    setShowNavigationMenu(!showNavigationMenu);
  };
  return (
    <>
      <div
        className={classNames}
        style={{ height: 64, zIndex: 12, backgroundColor: "white" }}
      >
        <div className={classNamesNavbar}>
          <div className="container-breadcrumb">
            <div>Piala by.U</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              style={{ marginBottom: 2 }}
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.52656 12.2052C5.26851 12.4633 5.26851 12.8817 5.52656 13.1397C5.78461 13.3978 6.203 13.3978 6.46106 13.1397L7.8628 11.738C8.12086 11.4799 8.12086 11.0615 7.8628 10.8035C7.60475 10.5454 7.18636 10.5454 6.92831 10.8035L5.52656 12.2052ZM6.46105 2.86013C6.20299 2.60207 5.7846 2.60207 5.52655 2.86013C5.26849 3.11818 5.26849 3.53657 5.52655 3.79462L9.73178 7.99986L8.79729 8.93436C8.53923 9.19241 8.53923 9.6108 8.79729 9.86885C9.05534 10.1269 9.47373 10.1269 9.73178 9.86885L11.1335 8.46711C11.3916 8.20905 11.3916 7.79067 11.1335 7.53261L6.46105 2.86013Z"
                fill="#6A7481"
              />
            </svg>
            <b>Registrasi</b>
          </div>
          {!!citySchool?.slug && categoryCompetition?.length > 0 && (
            <div style={{ marginLeft: "auto" }}>
              <Button
                className={"navbar__container__d-button--ticket"}
                variant={"primary-white"}
                size={"small"}
                onClick={() =>
                  toglePopUp({
                    state: true,
                    data: { competition: categoryCompetition },
                    currentCity: citySchool?.slug,
                    typePopUp: "show-info-regist",
                    registStartDate:
                      categoryCompetition?.toLowerCase() === "dance"
                        ? citySchool?.dance_registration_start_date
                        : citySchool?.registration_start_date,
                    registEndDate:
                      categoryCompetition?.toLowerCase() === "dance"
                        ? citySchool?.dance_registration_end_date
                        : citySchool?.registration_end_date,
                    registAnnounceDate:
                      categoryCompetition?.toLowerCase() === "dance"
                        ? citySchool?.dance_registration_announcement_date
                        : citySchool?.registration_announcement_date,
                  })
                }
              >
                <b style={{ fontSize: 14 }}>Info Registrasi</b>
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

NavBarBreadCrumb.propTypes = {
  menus: PropTypes.array,
  className: PropTypes.string,
};

NavBarBreadCrumb.defaultProps = {
  menus: "",
  className: "",
};

export default NavBarBreadCrumb;
